import React, { useEffect, useRef } from "react";
import { handleDecodeURL } from "../../utils";

export default function ECPay(props) {
  const formRef = useRef(null);
  const decodedString = atob(decodeURIComponent(props.token));
  const searchParams = new URLSearchParams(decodedString);
  const action = searchParams.get("action");

  useEffect(() => {
    formRef.current.submit();
  }, []);
  return (
    <form
      ref={formRef}
      method="POST"
      action={handleDecodeURL(action)}
    >
      {[...searchParams.entries()].map(([key, value]) => {
        if (key === "action" || key === "gateway" || key === "redirect") return null;
        return (
          <input
            type="hidden"
            name={key}
            key={key}
            value={handleDecodeURL(value)}
          />
        );
      })}
    </form>
  );
}
